module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_26.b6099b87.pdf";